import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { TypedUseSelectorHook } from 'react-redux';
import snackbarReducer from './slices/snackbarSlice';
import loaderReducer from './slices/loaderSlice';
import authReducer from './slices/authSlice';
import categoryReducer from './slices/categorySlice';
import subCategoryReducer from './slices/subCategorySlice';
import productsReducer from './slices/productsSlice';
import storesReducer from './slices/storesSlice';
import storeProductsReducer from './slices/storeProductSlice';
import ordersReducer from './slices/ordersSlice';
import orderProcessingReducer from './slices/orderProcessingSlice';
import shippingsReducer from './slices/shippingsSlice';
import languageReducer from './slices/languagesSlice';
import ingredientsReducer from './slices/ingredientsSlice';
import userProfileReducer from './slices/GetUserProfileSlice';
import messagesReducer from './slices/messagesSlice';
import allStoresReducer from './slices/messageStoreSlice';
import productionPlanReducer from './slices/productionPlanSlice';
import recipesReducer from './slices/recipeBuilderSlice';
import invoiceReducer from './slices/invoiceSlice';
import productionReportReducer from './slices/productionReportSlice';
import taxesReducer from './slices/taxesSlice';
import shippingMethodsReducer from './slices/shippingMethodsSlice';
import countryReducer from './slices/countriesSlice';
import statesReducer from './slices/statesSlice';
import confirmProductionReducer from './slices/confirmProductionSlice';
import dropdownDataReducer from './slices/dropdownDataSlice';

export const store = configureStore({
  reducer: {
    loader: loaderReducer,
    snackbar: snackbarReducer,
    auth: authReducer,
    category: categoryReducer,
    subCategory: subCategoryReducer,
    products: productsReducer,
    stores: storesReducer,
    storeProduct: storeProductsReducer,
    orders: ordersReducer,
    orderProcessing: orderProcessingReducer,
    shippings: shippingsReducer,
    languages: languageReducer,
    ingredients: ingredientsReducer,
    userProfile: userProfileReducer,
    messages: messagesReducer,
    allStores: allStoresReducer,
    productionPlan: productionPlanReducer,
    recipes: recipesReducer,
    invoice: invoiceReducer,
    productionReport: productionReportReducer,
    taxes: taxesReducer,
    shippingMethods: shippingMethodsReducer,
    country: countryReducer,
    states: statesReducer,
    confirmProduction: confirmProductionReducer,
    dropdownData: dropdownDataReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates']
      }
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
